<template>
  <div class="accordion-item" :class="{'active': showContent}">
    <div class="heading-bounder" v-if="hasHeading" @click="showFAQ">
      <slot name="heading" :toggle="showFAQ"></slot>
    </div>
    <div class="heading-bounder" v-else :class="lclass" @click="showFAQ">
      <div class="heading mb-2 heading-h4-18-semi">
        <p class="title noselect pr-1">{{item.title}}</p>

        <div class="toggle ml-auto">
          <i class="icon icon-plus-circle" v-if="showContent == false"></i>

          <i class="icon icon-minus-circle" v-else></i>
        </div>
      </div>
    </div>

    <TransitionExpand>
      <PerfectScrollbar class="content" :class="cClass" v-if="hasItems">
        <slot name="items" v-if="showContent" @click.stop></slot>
      </PerfectScrollbar>
      <template v-if="!hasItems">
        <PerfectScrollbar class="content mb-2 paragraph-14-regular" v-html="item.content" v-if="showContent" @click.stop></PerfectScrollbar>
      </template>
    </TransitionExpand>
  </div>
</template>

<script>
export default {
  name: "GpAccordion",
  props: {
    item: {
      type: Object
    },
    cClass: String,
    lclass: String,
    showFirst: {
      type: Boolean,
      default: false
    },
    forceShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showContent: false
    };
  },
  computed: {
    hasItems() {
      return !!this.$slots["items"] || !!this.$scopedSlots["items"];
    },
    hasHeading() {
      return !!this.$slots["heading"] || !!this.$scopedSlots["heading"];
    }
  },
  watch: {
    forceShow(newV) {
      if (newV) {
        this.showContent = true;
      }
    }
  },
  created() {
    if (this.forceShow) {
      this.showContent = true;
    }
    if (this.showFirst) {
      this.showContent = true;
    }
  },
  methods: {
    showFAQ(cond = false) {
      if (cond === true) {
        this.showContent = true;
        return;
      }
      this.showContent = !this.showContent;
    }
  },
};
</script>

<style lang="scss" scoped>
.accordion-item {
  padding: 0;
  background: #fff;

  &:not(:last-of-type) {
    border-bottom: 1px solid $grey3;
  }

  > .heading-bounder {
    display: flex;
    flex: 1;
    margin: -20px -20px 0 -20px;
    padding: 20px 20px 0 20px;
    cursor: pointer;
    .heading {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex: 1;

      > .title {
        color: map-get($dark-text-new, "high-contrast");
      }

      > .toggle {
        font-size: 20px;
        display: flex;
      }
    }

    &:hover {
      .heading {
        color: $mono3 !important;
        .title {
          color: $mono3 !important;
        }
      }
    }
  }

  > .content {
    color: map-get($dark-text-new, "low-contrast");
  }

  &:not(:first-of-type) {
    margin-top: 24px;
  }
}
</style>
